import CancellationPolicy from "components/cancellationPolicy";
import { cancellationPolicy } from "../chart/types";
import CFNR from "components/cfnr";
import { FLOW } from "constants/common";
import { FareCards } from "../itinerary/types";

const Cancellation = ({
  data,
  cfnrInfo,
}: {
  data: cancellationPolicy | undefined;
  cfnrInfo: FareCards;
}) => {
  return (
    <>
      <div className="mx-4 mt-6 p-relative">
        <CancellationPolicy cancellationPolicyData={data} flow={FLOW.PRE} />

        <div className="mt-8">
          {cfnrInfo?.isEligible ? (
            <CFNR
              description={cfnrInfo?.description?.text}
              addBackground
              titleLogo={cfnrInfo.titleURL}
              height={24}
              width={75}
              showingAsBanner
            />
          ) : null}
        </div>
      </div>
    </>
  );
};

export default Cancellation;
